import { render, staticRenderFns } from "./StudipAssetImg.vue?vue&type=template&id=4d910512&"
import script from "./StudipAssetImg.vue?vue&type=script&lang=js&"
export * from "./StudipAssetImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v4.6-hsfl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d910512')) {
      api.createRecord('4d910512', component.options)
    } else {
      api.reload('4d910512', component.options)
    }
    module.hot.accept("./StudipAssetImg.vue?vue&type=template&id=4d910512&", function () {
      api.rerender('4d910512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/StudipAssetImg.vue"
export default component.exports